import axios from 'axios';

import auth from "@/store/authentication.js";
const user_role = auth.state.user_role;

export default {
  findAll(ctx) {
    return axios.get(api_url + user_role + "/projects", {
      params: { ctx: ctx }
    });
  },
  find(id) {
    return axios.get(api_url + user_role + "/projects/" + id);
  },
  getSteps(id) {
    let projectId = (id !== null) ? "/" + id : "";
    return axios.get(api_url + user_role + "/projects/steps" + projectId);
  },
  getMixedSteps(id) {
    let projectId = (id !== null) ? "/" + id : "";
    return axios.get(api_url + user_role + "/projects/mix_steps" + projectId);
  },
  create(params) {
    return axios.post(api_url + user_role + "/projects", params);
  },
  findProject(id) {
    return axios.get(api_url + user_role + "/events/projects/" + id);
  },
  findAkeneo(id) {
    return axios.get(api_url + user_role + "/projects/get-pack-akeneo/" + id);
  },
  create_nwf(params) {
    return axios.post(api_url + user_role + "/projects/no-wf", params);
  },
  update(params) {
    return axios.post(api_url + user_role + "/projects/" + params.id + "/save", params.entity);
  },
  delete(id) {
    return axios.delete(api_url + user_role + "/projects/" + id);
  },
  fields() {
    return axios.get(api_url + user_role + "/projects/fields");
  },
}



// WEBPACK FOOTER //
// ./src/api/project.js